import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight } from 'lucide-react';

export const AboutPreview = () => {
  const images = [
    // Bathroom 1 - white modern bathroom
    'https://images.unsplash.com/photo-1722153151852-c2c1a61e98c9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBraXRjaGVuJTIwcmVub3ZhdGlvbiUyMGx1eHVyeSUyMGJhdGhyb29tJTIwcmVtb2RlbCUyMGN1c3RvbSUyMGhvbWUlMjBleHRlcmlvcnxlbnwwfHx8fDE3NzM0MzUyNTJ8MA&ixlib=rb-4.1.0&q=85',
    // Kitchen 1 - modern kitchen with island
    'https://images.unsplash.com/photo-1772567732969-c1506edf80a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBraXRjaGVuJTIwcmVub3ZhdGlvbiUyMHJlbW9kZWx8ZW58MHx8fHwxNzc0NDUxMzE5fDA&ixlib=rb-4.1.0&q=85',
    // Bathroom 2 - concrete bathroom with pendant light
    'https://images.unsplash.com/photo-1723257141691-144eadabb18a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBraXRjaGVuJTIwcmVub3ZhdGlvbiUyMGx1eHVyeSUyMGJhdGhyb29tJTIwcmVtb2RlbCUyMGN1c3RvbSUyMGhvbWUlMjBleHRlcmlvcnxlbnwwfHx8fDE3NzM0MzUyNTJ8MA&ixlib=rb-4.1.0&q=85',
    // Kitchen 2 - open concept kitchen with bar stools
    'https://images.unsplash.com/photo-1773867567776-f727d0a6c1d4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBraXRjaGVuJTIwcmVub3ZhdGlvbiUyMHJlbW9kZWx8ZW58MHx8fHwxNzc0NDUxMzE5fDA&ixlib=rb-4.1.0&q=85',
  ];

  return (
    <section data-testid="about-preview" className="py-24 bg-off-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Text Content */}
          <div className="space-y-8">
            <div>
              <span className="text-copper text-xs font-inter uppercase tracking-widest">
                About Us
              </span>
              <h2 
                className="text-4xl md:text-5xl font-playfair font-bold text-navy mt-4 leading-tight"
                data-testid="about-headline"
              >
                Home Improvement Specialists
              </h2>
            </div>
            
            <p className="text-navy/70 font-inter leading-relaxed text-lg">
              Welcome to C.A.B Enterprises, your trusted home improvement experts, dedicated to transforming homes with precision and care. With years of experience in building kitchens, bathrooms, garages, and more, we take pride in delivering top-quality craftsmanship and a seamless customer experience.
            </p>
            
            <p className="text-navy/70 font-inter leading-relaxed">
              Our mission is to bring your vision to life while ensuring clear communication and expert guidance at every step. Let's create a home you'll love!
            </p>

            <Link to="/about">
              <Button 
                data-testid="about-cta"
                variant="outline"
                className="border-2 border-navy text-navy hover:bg-navy hover:text-white px-8 py-6 text-xs font-bold uppercase tracking-widest group"
              >
                Learn More About Us
                <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
              </Button>
            </Link>
          </div>

          {/* Image Grid - 4 images */}
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-4">
              <div className="overflow-hidden">
                <img
                  src={images[0]}
                  alt="Bathroom renovation"
                  className="w-full h-48 object-cover hover:scale-105 transition-transform duration-500"
                  data-testid="about-image-1"
                />
              </div>
              <div className="overflow-hidden">
                <img
                  src={images[1]}
                  alt="Kitchen remodel"
                  className="w-full h-48 object-cover hover:scale-105 transition-transform duration-500"
                  data-testid="about-image-2"
                />
              </div>
            </div>
            <div className="space-y-4 pt-8">
              <div className="overflow-hidden">
                <img
                  src={images[2]}
                  alt="Luxury bathroom"
                  className="w-full h-48 object-cover hover:scale-105 transition-transform duration-500"
                  data-testid="about-image-3"
                />
              </div>
              <div className="overflow-hidden">
                <img
                  src={images[3]}
                  alt="Modern kitchen"
                  className="w-full h-48 object-cover hover:scale-105 transition-transform duration-500"
                  data-testid="about-image-4"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutPreview;
